import { render, staticRenderFns } from "./PublicQuotationPages2.vue?vue&type=template&id=43d07126&scoped=true&"
import script from "./PublicQuotationPages2.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d07126",
  null
  
)

export default component.exports